<template>
  <div>
    <a href="javascript:;" class="btn-wifi" @click="modalShow = true"></a>
    <base-modal :visible.sync="modalShow">
      <div class="content">
        <div class="title"><span>船上轻松连接6步骤</span></div>
        <div class="steps">
          <div class="step-item" v-for="(item, index) in stepsText" :key="index">
            <img class="icon" :src="require(`../../assets/wifi_step${index+1}.png`)" alt="">
            <p class="item-text">{{item}}</p>
          </div>
        </div>
      </div>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '@/components/BaseModal'

export default {
  name: 'BookingWifiInfo',

  components: {
    BaseModal
  },

  data () {
    return {
      modalShow: false,
      stepsText: ['打开“设置-WLAN”，连接“WIFI-Guest-船名”', '在弹出的页面中点击“连接互联网”', '点击“创建互联网账户”输入船票及账户信息', '登陆后账户内将自动显示您预订的套餐信息', '点击“激活互联网”', '点击“开始吧”畅享高速超凡网络']
    }
  }
}
</script>

<style lang="less" scoped>
.btn-wifi {
  position: fixed;
  right: 20px;
  bottom: 200px;
  z-index: 5;
  width: 78px;
  height: 78px;
  border-radius: 50%;
  background: rgba(5, 1, 1, .6) url('../../assets/icons/icon_wifi.png') center center no-repeat;
  background-size: 48px auto;
}
.content {
  padding: 0 40px 30px;
  .title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 140px;
    font-size: 30px;
    color: #000;
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      z-index: 1;
      width: 140px;
      height: 4px;
      margin-top: -2px;
      background-color: @second-color;
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
  }
  .steps {
    display: flex;
    flex-wrap: wrap;
    .step-item {
      flex: none;
      width: 33.333333333333%;
      .icon {
        display: block;
        width: 112px;
        height: 112px;
        margin: 0 auto;
      }
      .item-text {
        width: 150px;
        height: 110px;
        padding-top: 16px;
        box-sizing: border-box;
        margin: 0 auto;
        font-size: 16px;
        color: #333;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
</style>
